export const projectsList = [
    {
        title: "Beeranza Website/Ecommerce",
        technologies: ["React", "TypeScript", "Supabase", "Tailwind CSS", "Stripe API"],
        description: "Ecommerce created for a beer company in Italy using React and Supabase, including admin dashboard and custom beer cans editor",
        link: "https://beeranza.netlify.app/",
        image: "beeranza-ecommerce.png",
        isActive: true,
    },
    // {
    //     title: "13ft Ladder",
    //     technologies: ["Python", "Docker"],
    //     description: "Self-hosted paywall and ad bypasser. Fork of 13ft with PWA support, Android share menu integration, and Cloudflare bypass.",
    //     link: "https://one3ft-wqxv.onrender.com/",
    //     image: "13ft.png",
    //     isActive: true,
    // },
    {
        title: "BBackup",
        technologies: ["Python", "Supabase", "React", "Tailwind CSS", "Restic"],
        description: "Backup management application based on Restic to allow seamless cross-platform backups and restores",
        link: "",
        image: "bbackup.png",
        isActive: false,
    },
    {
        title: "Milor ecommerce and catalog Odoo integration",
        technologies: ["Odoo", "Python"],
        description: "Odoo integration for a Milan based jewels wholesaler to handle products catalogs and ecommerce orders",
        link: "",
        image: "milor.png",
        isActive: false,
    },
    {
        title: "Terna hardware failure management app",
        technologies: ["Angular", "TypeScript", "Golang"],
        description: "Web app for Terna SPA to monitor and manage hardware failures",
        link: "",
        image: "terna.png",
        isActive: false,
    },
    // {
    //     title: "TwiBooter",
    //     technologies: ["Vercel", "AWS Lambda", "Python", "React", "TypeScript", "Chakra UI"],
    //     description: "Demo app for scaping data from Twitch and creating shorts ready to be uploaded on Youtube or TikTok",
    //     link: "https://twi-booter.vercel.app/",
    //     image: "twiBooter.png",
    //     isActive: true,
    // },
    // {
    //     title: "Tod's NPS",
    //     technologies: ["Netlify", "React", "TypeScript", "Chakra UI", "React Hook Form"],
    //     description: "Multistep NPS (NET PROMOTER SCORE) form created for TOD's Group during a project work ",
    //     link: "https://incredible-lollipop-7bd6e5.netlify.app/",
    //     image: "TodsNPS.png",
    //     isActive: true,
    // },
    // {
    //     title: "Javascript Conference",
    //     technologies: ["Netlify", "Render", "React", "TypeScript", "Chakra UI", "React Router", "JSON Server", "React Query"],
    //     description: "Two pages demo website showcasing events and speakers of the JSWorld Conference, with a Json-Server mock DB hosted on heroku",
    //     link: "https://chipper-churros-38c03e.netlify.app/",
    //     image: "conference.png",
    //     isActive: true,
    // },
    // {
    //     title: "Movie App",
    //     technologies: ["Netlify", "React", "TypeScript", "Chakra UI"],
    //     description: "Demo app using IMDb APIs to show a list of films/games/series and relative detail created to learn React.JS fundamentals",
    //     link: "https://lucent-croissant-289388.netlify.app/",
    //     image: "movieApp.png",
    //     isActive: true,
    // },
    {
        title: "Meal Vouchers Admin Dashboard",
        technologies: ["React", "TypeScript", "Chakra UI", "React Router", "React Query"],
        description: "Admin Dashboard for managing meal vouchers and monitoring affiliated businesses",
        link: "",
        image: "foodStamps.png",
        isActive: false,
    },
    {
        title: "Courses Admin Dashboard",
        technologies: ["React", "TypeScript", "Chakra UI", "React Router", "React Query", "MSAL Library"],
        description: "Admin Dashboard for managing courses and participants ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ",
        link: "",
        image: "courses.png",
        isActive: false,
    },
]


export const projectColors = [
    { technology: "React", color: "#61DAFB" },
    { technology: "Chakra UI", color: "#319795" },
    { technology: "Node.js", color: "#68A063" },
    { technology: "Python", color: "linear(to-r,#3776AB, #FFE263)" },
    { technology: "Netlify", color: "linear(to-r, #38B16D, #222DA9)" },
    { technology: "TypeScript", color: "#007ACC" },
    { technology: "Odoo", color: "#714B67" },
    { technology: "HTML", color: "#E34F26" },
    { technology: "CSS", color: "#1572B6" },
    { technology: "Javascript", color: "#F7DF1E" },
    { technology: "Vercel", color: "linear(to-r,#A065CF, #EC058A)" },
    { technology: "Render", color: "#2743F1" },
    { technology: "React Query", color: "linear(to-r,#EF4742, #F59A0E)" },
    { technology: "React Router", color: "linear(to-r,#F44250, #5b5b5b)" },
    { technology: "MSAL Library", color: "linear(to-r,#01a4ef,#81b900 ,#ffba08 ,#f44e24  )" },
    { technology: "React Hook Form", color: "#ec5990" },
    { technology: "AWS Lambda", color: "#ff9900" },
    { technology: "JSON Server", color: "#F7E025" },
    { technology: "Stripe API", color: "#635BFF" },
    { technology: "Supabase", color: "#63D7A2" },
    { technology: "Tailwind CSS", color: "#06B6D4" },
    { technology: "Restic", color: "#F7E06D" },
    { technology: "Golang", color: "#00ADD8" },
    { technology: "Angular", color: "#DD0031" },

];

